// extracted by mini-css-extract-plugin
export default {"rootStep":"StepAndBody_rootStep__BbOTQ"};